export default {
  amex: `${process.env.REACT_APP_ASSETS_ENDPOINT}/assets/credit-card-amex.svg`,
  discover: `${process.env.REACT_APP_ASSETS_ENDPOINT}/assets/credit-card-discover.svg`,
  error: `${process.env.REACT_APP_ASSETS_ENDPOINT}/assets/credit-card-error.svg`,
  mastercard: `${process.env.REACT_APP_ASSETS_ENDPOINT}/assets/credit-card-mastercard.svg`,
  placeholder: `${process.env.REACT_APP_ASSETS_ENDPOINT}/assets/credit-card-placeholder.svg`,
  visa: `${process.env.REACT_APP_ASSETS_ENDPOINT}/assets/credit-card-visa.svg`,
}